"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mileageToString = exports.isUnlimitedMileage = exports.UNLIMITED_MILEAGE = void 0;
exports.UNLIMITED_MILEAGE = 'Unlimited';
var isUnlimitedMileage = function (mileage) {
    var unlimitedValues = [9999999, 999999999, -1, 0];
    return unlimitedValues.indexOf(mileage) !== -1;
};
exports.isUnlimitedMileage = isUnlimitedMileage;
var mileageToString = function (mileage) {
    if ((0, exports.isUnlimitedMileage)(mileage)) {
        return exports.UNLIMITED_MILEAGE;
    }
    var mileageString = mileage.toString();
    var newLength = mileageString.length - 3;
    var kValue = newLength > 0 ? mileageString.substr(0, newLength) : '0';
    return "".concat(kValue, "k");
};
exports.mileageToString = mileageToString;
